import React from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import { DocContentImage, DocSidebarImage } from '../component/DocMedia';
import SettingsMenuOverview from './SettingsMenuOverview';
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function AccountSetting() {
  const { t } = useTranslation();
  const image001 = useDocImage('account-settings-img', 'image001.png', 'settings');
  const image002 = useDocImage('account-settings-img', 'image002.png', 'settings');
  const image008 = useDocImage('account-settings-img', 'image008.png', 'settings');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.accountSettings.title')}</h1>
            <p className="header-para">{t('documentation.accountSettings.intro')}</p>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.accountSettings.accessing.title')}
              </div>
              <div className="card-body">
                <SettingsMenuOverview />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.accountSettings.accessing.steps.step1') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.accountSettings.accessing.steps.step2') }} />
                </ul>
                <DocSidebarImage src={image001} alt={t('documentation.accountSettings.accessing.imageAlt')} />
                <ul className="mb-0">
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.accountSettings.accessing.steps.step3') }} />
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.accountSettings.availableFields.title')}
              </div>
              <div className="card-body">
                <DocContentImage
                  src={image002}
                  alt={t('documentation.accountSettings.availableFields.generalInfo.imageAlt')}
                />
                <p><b>{t('documentation.accountSettings.availableFields.generalInfo.title')}</b></p>
                <ul>
                  <li>{t('documentation.accountSettings.availableFields.generalInfo.profilePhoto')}</li>
                  <li>{t('documentation.accountSettings.availableFields.generalInfo.email')}</li>
                  <li>{t('documentation.accountSettings.availableFields.generalInfo.userName')}</li>
                </ul>

                <p className="mt-3"><b>{t('documentation.accountSettings.availableFields.localization.title')}</b></p>
                <ul>
                  <li>{t('documentation.accountSettings.availableFields.localization.region')}</li>
                  <li>{t('documentation.accountSettings.availableFields.localization.country')}</li>
                  <li>{t('documentation.accountSettings.availableFields.localization.timeZone')}</li>
                  <li>{t('documentation.accountSettings.availableFields.localization.defaultLanguage')}</li>
                </ul>

                <p className="mt-3"><b>{t('documentation.accountSettings.availableFields.savingChanges.title')}</b></p>
                <ul>
                  <li>{t('documentation.accountSettings.availableFields.savingChanges.step1')}</li>
                  <li>{t('documentation.accountSettings.availableFields.savingChanges.step2')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.accountSettings.assignedTeamsRoles.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.accountSettings.assignedTeamsRoles.intro')}</p>
                <DocContentImage
                  src={image008}
                  alt={t('documentation.accountSettings.assignedTeamsRoles.imageAlt')}
                />
                <ul>
                  <li>{t('documentation.accountSettings.assignedTeamsRoles.teams')}</li>
                  <li>{t('documentation.accountSettings.assignedTeamsRoles.roles')}</li>
                </ul>
                <p>{t('documentation.accountSettings.assignedTeamsRoles.conclusion')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
